<template>
  <section class="contact py-16 bg-gray-100" id="contact">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 class="text-4xl font-bold text-center text-gray-800 mb-8">Kontakt</h2>
      <p class="text-center text-lg text-gray-600 mb-12">
        Besuche uns oder kontaktiere uns für mehr Informationen.
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Kontaktformular -->
        <div>
          <form class="bg-white shadow-md rounded-lg px-8 py-6">
            <div class="mb-4">
              <label for="name" class="block text-gray-700 text-sm font-bold mb-2">Name</label>
              <input type="text" id="name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Dein Name" />
            </div>
            <div class="mb-4">
              <label for="email" class="block text-gray-700 text-sm font-bold mb-2">E-Mail</label>
              <input type="email" id="email" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="Deine E-Mail" />
            </div>
            <div class="mb-4">
              <label for="message" class="block text-gray-700 text-sm font-bold mb-2">Nachricht</label>
              <textarea id="message" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" rows="4" placeholder="Deine Nachricht"></textarea>
            </div>
            <div class="flex items-center justify-between">
              <button type="submit" class="bg-teal-600 hover:bg-teal-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                Senden
              </button>
            </div>
          </form>
        </div>
        <!-- Kontaktinformationen -->
        <div class="bg-white shadow-md rounded-lg px-8 py-6">
          <h3 class="text-2xl font-bold text-gray-800 mb-4">Unsere Kontaktinformationen</h3>
          <div class="text-gray-700 mb-6">
            <div class="flex flex-wrap gap-2 mb-4">
              <button
                v-for="loc in locations"
                :key="loc.id"
                type="button"
                @click="activeLocation = loc.id"
                :class="[
                  'px-3 py-1.5 rounded-full text-sm font-semibold transition',
                  activeLocation === loc.id
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                ]"
              >
                {{ loc.name }}
              </button>
            </div>

            <div v-for="loc in locations" :key="`${loc.id}-panel`" v-show="activeLocation === loc.id">
              <p class="flex items-center mb-2">
                <strong class="mr-2">Adresse:</strong>
                {{ loc.address }}
              </p>
              <p class="flex items-center mb-4">
                <a :href="loc.mapUrl" target="_blank" class="text-teal-500 hover:text-teal-600 flex items-center">
                  <img src="@/assets/google-maps-icon.svg" alt="Google Maps" class="w-5 h-5 mr-2" />
                  <span>Auf Google Maps ansehen</span>
                </a>
              </p>

              <div v-if="loc.images.length" class="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <img
                  v-for="(img, idx) in loc.images"
                  :key="`${loc.id}-${idx}`"
                  :src="img"
                  :alt="`${loc.name} Bild ${idx + 1}`"
                  class="h-24 w-full object-cover rounded-md shadow-sm"
                  loading="lazy"
                />
              </div>
              <p v-else class="text-sm text-gray-500">Für diesen Standort sind noch keine Bilder hinterlegt.</p>
            </div>
          </div>
          <p class="text-gray-700 mb-4">
            <strong>E-Mail:</strong> Info@classic-specialty-coffee.com
          </p>
          <p class="text-gray-700">
            <strong>Öffnungszeiten:</strong><br>
            Montag - Freitag: 8:30 - 18:00<br>
            Samstag - Sonntag: 10:00 - 18:00
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      activeLocation: 'falckenstein',
      locations: [
        {
          id: 'falckenstein',
          name: 'Standort Kreuzberg',
          address: 'Falckensteinstrasse 4, 10997 Berlin',
          mapUrl: 'https://g.co/kgs/usi8Cdx',
          images: [
            new URL('@/assets/Galerie/image1-web.jpg', import.meta.url).href,
            new URL('@/assets/Galerie/image2-web.jpg', import.meta.url).href,
            new URL('@/assets/Galerie/image3-web.jpg', import.meta.url).href,
            new URL('@/assets/Galerie/image4-web.jpg', import.meta.url).href,
          ],
        },
        {
          id: 'gruenenberger',
          name: 'Standort Friedrichshain (neu eröffnet)',
          address: 'Grünenbergerstr. 58, 10245 Berlin',
          mapUrl: 'https://www.google.com/maps/search/?api=1&query=Gr%C3%BCnenbergerstr.%2058%2C%2010245%20Berlin',
          images: [
            new URL('@/assets/Neuer Standort/newlocation-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/neuerlocation2-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/WhatsApp Image 2026-02-07 at 17.23.30-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/WhatsApp Image 2026-02-07 at 17.25.02-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/WhatsApp Image 2026-02-07 at 17.25.14-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/neuer1-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/neuer2-web.jpg', import.meta.url).href,
            new URL('@/assets/Neuer Standort/neuer3-web.jpg', import.meta.url).href,
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
